import React from 'react';
import { BrowserRouter } from 'react-router-dom'

function App() {
  return (
    <div className="App">
      <BrowserRouter basename={window.__POWERED_BY_QIANKUN__ ? '/sales' : '/'}>
        React(MicroApp) Sales
      </BrowserRouter>
    </div>
  );
}

export default App;
